import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Swal from "sweetalert2";
import api from "../../../Services/api";
import { IoWarningOutline } from "react-icons/io5";
import CadastroQuestaoOpcoesModal from "./cadastroQuestaoOpcoesModal";

import "./cadastroQuestaoModal.css";

const tipos = [
    { value: 1, label: "Sim / Não" },
    { value: 2, label: "Conforme / Não Conforme" },
    { value: 3, label: "Texto" },
    { value: 4, label: "Múltipla escolha" },
    { value: 5, label: "Única escolha" },
];

const CadastroQuestaoModal = ({ open, questao, secaoID = null, onClose, onSaved }) => {
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showOpcoesModal, setShowOpcoesModal] = useState(false);
    const [questaoIdLocal, setQuestaoIdLocal] = useState(null);

    const [form, setForm] = useState({
        titulo: "",
        descricao: "",
        tipo: 1,
        habilitaAnalise: 0,
        questaoModelo: 0,
        situacao: 1,
        qntRespostas: 0,
        ordem: 1
    });

    const formQuestaoSecao = {
        IDQuestao: 0,
        IDSecao: secaoID || 0,
        IDObjeto: null,
        ordem: null
    };
    const [secao, setSecao] = useState(null);

    const calcularProximaOrdem = (lista = []) => {
        const usadas = new Set();
        let max = 0;
        lista.forEach((item) => {
            const ordem = Number(item?.ordem);
            if (Number.isFinite(ordem) && ordem > 0) {
                usadas.add(ordem);
                if (ordem > max) max = ordem;
            }
        });
        for (let i = 1; i <= max + 1; i += 1) {
            if (!usadas.has(i)) return i;
        }
        return max + 1;
    };

    useEffect(() => {
        if (!open) return;
        setQuestaoIdLocal(questao?.IDQuestao ?? null);

        const carregarDados = async () => {
            setLoading(true);

            try {
                // carrega seção
                if (secaoID) {
                    const response = await api.get(`/chksecao/${secaoID}`);
                    setSecao(response.data);
                } else {
                    setSecao(null);
                }

                // preenche formulário
                if (questao) {
                    setForm({
                        titulo: questao.titulo,
                        descricao: questao.descricao,
                        tipo: questao.tipo,
                        habilitaAnalise: questao.habilitaAnalise ?? 0,
                        questaoModelo: questao.questaoModelo ?? 0,
                        situacao: questao.situacao ?? 1,
                        qntRespostas: questao.qntRespostas ?? 0,
                        ordem: questao.ordem ?? 1
                    });
                } else {
                    setForm({
                        titulo: "",
                        descricao: "",
                        tipo: 1,
                        habilitaAnalise: 0,
                        questaoModelo: 0,
                        situacao: 1,
                        qntRespostas: 0,
                        ordem: 1
                    });
                    if (secaoID) {
                        try {
                            const responseTotal = await api.get(`/chkquestaosecao/secao`, {
                                params: { page: 1, limit: 1, IDSecao: secaoID, filter: "" },
                            });
                            const total = responseTotal.data?.total ?? 0;
                            let lista = responseTotal.data?.data ?? [];
                            if (total > lista.length) {
                                const responseAll = await api.get(`/chkquestaosecao/secao`, {
                                    params: { page: 1, limit: total, IDSecao: secaoID, filter: "" },
                                });
                                lista = responseAll.data?.data ?? [];
                            }
                            const proximaOrdem = calcularProximaOrdem(lista);
                            setForm((prev) => ({ ...prev, ordem: proximaOrdem }));
                        } catch (err) {
                            console.error("Erro ao buscar próxima ordem", err);
                        }
                    }
                }

            } catch (error) {
                console.error("Erro ao carregar dados do modal", error);
            } finally {
                setLoading(false);
            }
        };

        carregarDados();
    }, [open, questao, secaoID]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "ordem") {
            const parsed = Number(value);
            setForm((prev) => ({
                ...prev,
                ordem: Number.isFinite(parsed) ? parsed : "",
            }));
            return;
        }
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const salvarQuestao = async ({ keepOpen = false, showSuccess = true } = {}) => {
        if (!form.titulo.trim()) {
            await Swal.fire("Atenção", "O campo Título é obrigatório.", "warning");
            return null;
        }

        if (!form.descricao.trim()) {
            await Swal.fire("Atenção", "O campo Descrição é obrigatório.", "warning");
            return null;
        }

        try {
            setSaving(true);

            Swal.fire({
                title: "Salvando...",
                text: "Aguarde enquanto salvamos os dados.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => Swal.showLoading(),
            });

            const { qntRespostas, ordem, ...novaQuestao } = form;
            let questaoId = questao?.IDQuestao ?? questaoIdLocal;
            if (questaoId) {
                await api.put(`/chkquestao/${questaoId}`, novaQuestao);
            } else {
                const response = await api.post(`/chkquestao`, novaQuestao);
                if (response && secaoID) {
                    await api.post(`/chkquestaosecao`,
                        {
                            ...formQuestaoSecao,
                            IDQuestao: response.data.IDQuestao,
                            IDSecao: secaoID,
                            IDObjeto: null,
                            ordem: Number.isFinite(Number(form.ordem)) ? Number(form.ordem) : null
                        });
                }
                questaoId = response?.data?.IDQuestao ?? null;
                setQuestaoIdLocal(questaoId);
            }

            Swal.close();

            if (showSuccess) {
                await Swal.fire({
                    icon: "success",
                    title: "Sucesso!",
                    text: "Questão salva com sucesso.",
                });
            }

            onSaved();
            if (!keepOpen) {
                onClose();
            }

            return questaoId;
        } catch (error) {
            console.error("Erro ao salvar questão:", error);

            Swal.fire({
                icon: "error",
                title: "Erro ao salvar",
                text: error.response?.data?.message || "Ocorreu um erro inesperado.",
            });
            return null;
        } finally {
            setSaving(false);
        }
    };

    const salvar = async () => {
        await salvarQuestao();
    };

    const abrirModalOpcoes = async () => {
        const questaoId = questao?.IDQuestao ?? questaoIdLocal;
        if (!questaoId) {
            const criadoId = await salvarQuestao({ keepOpen: true, showSuccess: false });
            if (!criadoId) return;
        }
        setShowOpcoesModal(true);
    };

    const excluir = async () => {
        if (!questao) return;

        const confirm = await Swal.fire({
            title: "Excluir Questão?",
            text: "Essa ação é irreversível. Deseja realmente excluir esta questão?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, excluir",
            cancelButtonText: "Cancelar",
            cancelButtonColor: "var(--color-btnCancelar-danger)",
            customClass: {
                cancelButton: "swal-cancel-danger",
            },
        });

        if (!confirm.isConfirmed) return;

        try {
            setSaving(true);

            Swal.fire({
                title: "Excluindo...",
                text: "Aguarde enquanto excluímos a questão.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => Swal.showLoading(),
            });

            await api.delete(`/chkquestao/${questao.IDQuestao}`);

            Swal.close();

            await Swal.fire({
                icon: "success",
                title: "Excluída!",
                text: "Questão excluída com sucesso.",
            });

            onSaved();
            onClose();

        } catch (error) {
            console.error("Erro ao excluir questão:", error);

            Swal.fire({
                icon: "error",
                title: "Erro ao excluir",
                text: error.response?.data?.message || "Ocorreu um erro inesperado.",
            });
        } finally {
            setSaving(false);
        }
    };


    if (!open) return null;

    if (loading) {
        return (
            <div className="cadQuestao-modal-overlay">
                <div className="cadQuestao-modal">
                    <p>Carregando...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="cadQuestao-modal-overlay">
            <div className="cadQuestao-modal">

                <h3 className="cadQuestao-title">
                    {questao ? "Editar Questão" : "Nova Questão"}
                </h3>

                <div className="cadQuestao-form">
                    {secao && (<div className="cadQuestao-field">
                        <label>Seção</label>
                        <input
                            type="text"
                            name="secao"
                            value={secao.descricao}
                            disabled
                        />
                    </div>)}

                    {/* TÍTULO */}
                    <div className="cadQuestao-field">
                        <label>Título</label>
                        <input
                            type="text"
                            name="titulo"
                            maxLength={150}
                            value={form.titulo}
                            onChange={handleChange}
                            disabled={questao?.qntRespostas > 0}
                        />
                    </div>

                    {/* DESCRIÇÃO */}
                    <div className="cadQuestao-field">
                        <label>Descrição</label>
                        <input
                            type="text"
                            name="descricao"
                            maxLength={500}
                            value={form.descricao}
                            onChange={handleChange}
                            disabled={questao?.qntRespostas > 0}
                        />
                    </div>

                    {secao && !questao && (
                        <div className="cadQuestao-row">
                            <div className="cadQuestao-field cadQuestao-field-ordem">
                                <label>Ordem<span style={{ fontSize: 10, paddingLeft: 5 }}>(Opcional)</span></label>
                                <input
                                    type="number"
                                    name="ordem"
                                    min={1}
                                    step={1}
                                    value={form.ordem}
                                    onChange={handleChange}
                                    onBlur={() => setForm(prev => ({ ...prev, ordem: prev.ordem || 1 }))}
                                />
                            </div>
                        </div>
                    )}

                    <div className="cadQuestao-row">

                        {/* SWITCH QUESTÃO MODELO */}
                        <div className="cadQuestao-field" style={{ marginTop: 10 }}>
                            <label>Questão Modelo?</label>
                            <small className="text-muted fs-small" style={{ fontSize: 10, paddingBottom: 10 }}>
                                Ative para tornar esta questão reutilizável em outras seções.
                            </small>

                            <Form.Check
                                type="switch"
                                id="questaoModelo"
                                label={form.questaoModelo === 1 ? "Sim" : "Não"}
                                checked={form.questaoModelo === 1}
                                onChange={(e) =>
                                    setForm((prev) => ({
                                        ...prev,
                                        questaoModelo: e.target.checked ? 1 : 0,
                                    }))
                                }
                            />
                        </div>

                        {/* SWITCH HABILITA ANÁLISE */}
                        <div className="cadQuestao-field" style={{ marginTop: 10 }}>
                            <label>Disponível para análise?</label>
                            <small className="text-muted fs-small" style={{ fontSize: 10, paddingBottom: 10 }}>
                                Ative para tornar comentários disponíveis para esta questão.
                            </small>

                            <Form.Check
                                type="switch"
                                id="habilitaAnalise"
                                label={form.habilitaAnalise === 1 ? "Sim" : "Não"}
                                checked={form.habilitaAnalise === 1}
                                onChange={(e) =>
                                    setForm((prev) => ({
                                        ...prev,
                                        habilitaAnalise: e.target.checked ? 1 : 0,
                                    }))
                                }
                            />
                        </div>

                    </div>

                    <div className="cadQuestao-row">
                        {/* SITUAÇÃO */}
                        <div className="cadQuestao-field">
                            <label>Situação</label>
                            <select name="situacao" value={form.situacao} onChange={handleChange} disabled={questao?.qntRespostas > 0}>
                                <option value={1}>Ativo</option>
                                <option value={0}>Inativo</option>
                            </select>
                        </div>

                        {/* TIPO */}
                        <div className="cadQuestao-field">
                            <label>Tipo</label>
                            <select name="tipo" value={form.tipo} onChange={handleChange} disabled={questao?.qntRespostas > 0}>
                                {tipos.map((t) => (
                                    <option key={t.value} value={t.value}>
                                        {t.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {(Number(form.tipo) === 4 || Number(form.tipo) === 5) && (
                        <div className="cadQuestao-row">
                            <div className="cadQuestao-field">
                                <label>Opções</label>
                                <button
                                    type="button"
                                    className="cadQuestao-btn-secondary"
                                    onClick={abrirModalOpcoes}
                                    disabled={saving}
                                >
                                    Cadastrar opções
                                </button>
                            </div>
                        </div>
                    )}
                    {!secao && questao?.qntRespostas > 0 && (
                        <div>
                            <span style={{ fontSize: 12, color: 'red', padding: 0 }}><IoWarningOutline /> Esta questão já possui respostas preenchidas</span>
                        </div>
                    )}


                    {/* BOTÕES */}
                    <div className="cadQuestao-buttons">

                        {/* BOTÃO EXCLUIR — aparece só ao editar */}
                        {questao && (
                            <button
                                className="cadQuestao-btn-delete"
                                onClick={excluir}
                                disabled={saving}
                                style={{
                                    backgroundColor: "#d9534f",
                                    color: "white",
                                    marginRight: "auto"
                                }}
                            >
                                {saving ? "Aguarde..." : "Excluir"}
                            </button>
                        )}

                        <button className="cadQuestao-btn-cancel" onClick={onClose} disabled={saving}>
                            Cancelar
                        </button>

                        <button
                            className="cadQuestao-btn-save"
                            onClick={salvar}
                            disabled={saving}
                        >
                            {saving ? "Salvando..." : "Salvar"}
                        </button>
                    </div>
                </div>
            </div>

            {showOpcoesModal && (
                <CadastroQuestaoOpcoesModal
                    open={showOpcoesModal}
                    IDQuestao={questao?.IDQuestao ?? questaoIdLocal}
                    tituloQuestao={form.titulo}
                    onClose={() => setShowOpcoesModal(false)}
                />
            )}
        </div >
    )
}

export default CadastroQuestaoModal;
